import React from 'react';
import { connect } from 'react-redux';

import { ExpandControl as Control } from 'src/components/Mapbox/components/ExpandControl';

import {
  isExpandedMapSelector,
  isExpandableMapSelector,
} from 'src/routes/SearchPage/store/map/selectors';

import { toggleMap } from 'src/routes/SearchPage/store/map/slice';

const ExpandControl = (props): JSX.Element | null => {
  const { isExpanded, isExpandable, toggleHandler } = props;

  if (!isExpandable) return null;

  return <Control isExpanded={isExpanded} toggleHandler={toggleHandler} />;
};

const mapStateToProps = (state) => ({
  isExpanded: isExpandedMapSelector(state),
  isExpandable: isExpandableMapSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleHandler: () => dispatch(toggleMap()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpandControl);
